import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useCallback, useEffect } from "react";
import { QualidadeProcessosRiscosForm, QualidadeProcessosRiscosSchema } from "../../../schemas/ProcessosRiscos/qualidade_processos_riscos";
import { ProcessoRiscosLista } from "../../../../domain/models/processos_riscos_lista";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

// ProcessoRiscosModal 
 
type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedProcessoRiscos: ProcessoRiscosLista | undefined, 
  onClose: () => void;
  onSubmit: (e: QualidadeProcessosRiscosForm) => void;
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void,
};

export const ProcessoRiscosModal = ({
  open, saving,loading, selectedProcessoRiscos,onOpenChangeHistory,
  onClose, onSubmit
}: Props) => {

  const hookForm = useForm<QualidadeProcessosRiscosForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(QualidadeProcessosRiscosSchema),
  });

  useEffect(() => {
    if (open) {
        hookForm.reset(); 
        if (selectedProcessoRiscos) hookForm.setValue("Ano", Number(selectedProcessoRiscos.Ano));   
        else  hookForm.reset(); 
    }
  }, [hookForm, open, selectedProcessoRiscos]);

  const handleChangeHistory = useCallback(() => {
    if (selectedProcessoRiscos) {
      onOpenChangeHistory(selectedProcessoRiscos.IdProcesso, LogTipoTabela.PROCESSO);
    }
  }, [selectedProcessoRiscos, onOpenChangeHistory]);
  


  return (
  <Dialog
    open={open}
    maxWidth="md"
    fullWidth
    PaperProps={{
      component: 'form',
      onSubmit: hookForm.handleSubmit(onSubmit)
    }}
  >
    <DialogTitle>
      Cadastrar/Editar Ano
    </DialogTitle>

    <DialogContent>
      <FormContainer title={"Cadastrar/Editar"} arrangement="fullRow">
        <div className="flex flex-col gap-y-4 w-full pt-2">
          <DefaultFormInput
            name='Ano'
            label='Ano'
            required={true}
            reactHookForm={hookForm}
          />
        </div>
      </FormContainer>
    </DialogContent>

    <DialogActions>
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div>
            {
              isNotNullOrUndefined(selectedProcessoRiscos) &&
              <PrimaryButton
                buttonColor="yellow"
                onClick={handleChangeHistory}>
                <span className="text-xs">
                  Historico de alterações
                </span>
              </PrimaryButton>
            }
          </div>

          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={onClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  buttonColor="primary-green">
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
  </Dialog>
);
}